import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { media } from '../../styles/style-utils';
import GiftCard from '../main/giftCard/GiftCard';
import { BLOCK_TYPE } from '../main/utils/Contentful';

const MediaGrid = styled.div`
  --gap: ${props => props.gap || 'var(--default-horizontal-padding)'};

  display: grid;
  grid-column-gap: var(--gap);
  grid-row-gap: var(--gap);
  grid-template-columns: 1fr;

  ${media.large`
    --gap: 0;
    grid-template-columns: 1fr 1fr;
  `};
`;

const MediaGridText = styled.div`
  order: ${props => ((props.textPositionMobile || 'top').toLowerCase() === 'bottom' ? 2 : 1)};

  ${media.large`
    order: ${props => props.order || 2};
    align-self: center;
  `};
`;

const MediaGridMedia = styled.div`
  display: grid;
  max-width: 100%;
  order: ${props => ((props.textPositionMobile || 'top').toLowerCase() === 'bottom' ? 1 : 2)};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .mediaGridMobile {
    display: block;
  }

  .mediaGridDesktop {
    display: ${props => (props.$hasMobileSrc ? 'none' : 'block')};
  }

  ${media.large`
    order: ${props => (props.order === 1 ? 2 : 1)}
    align-self: stretch;

    .mediaGridMobile {
      display: none;
    }

    .mediaGridDesktop {
      display: block;
    }
  `};
`;

const embeddedToComponent = embedded => {
  if (embedded.sys.contentType.sys.id === BLOCK_TYPE.GIFT_UP) {
    return <GiftCard content={embedded.fields} />;
  }

  return null;
};

const MediaGridShell = ({
  children,
  srcSet,
  sizes,
  type,
  srcSet2,
  sizes2,
  type2,
  src,
  srcMobile,
  dimensions,
  dimensionsMobile,
  alt,
  order,
  textPositionMobile,
  gap,
  embedded,
}) => {
  return (
    <MediaGrid gap={gap}>
      <MediaGridText order={order} textPositionMobile={textPositionMobile} className="mediaText">
        {children}
      </MediaGridText>
      <MediaGridMedia
        textPositionMobile={textPositionMobile}
        $hasMobileSrc={Boolean(srcMobile)}
        className="mediaGrid"
      >
        {!embedded && (src || srcMobile) && (
          <React.Fragment>
            {srcMobile && (
              <img
                className="mediaGridMobile"
                src={srcMobile}
                {...(dimensionsMobile || {})}
                alt={alt}
              />
            )}
            {src &&
              (srcSet || srcSet2 ? (
                <picture className="mediaGridDesktop">
                  {srcSet && <source srcSet={srcSet} sizes={sizes} type={type} />}
                  {srcSet2 && <source srcSet={srcSet2} sizes={sizes2} type={type2} />}
                  <img src={src} {...(dimensions || {})} alt={alt} />
                </picture>
              ) : (
                <img className="mediaGridDesktop" src={src} {...(dimensions || {})} alt={alt} />
              ))}
          </React.Fragment>
        )}
        {embedded && <div>{embeddedToComponent(embedded)}</div>}
      </MediaGridMedia>
    </MediaGrid>
  );
};

MediaGridShell.propTypes = {
  children: PropTypes.node,
  srcSet: PropTypes.string,
  sizes: PropTypes.string,
  type: PropTypes.string,
  srcSet2: PropTypes.string,
  sizes2: PropTypes.string,
  type2: PropTypes.string,
  src: PropTypes.string,
  srcMobile: PropTypes.string,
  dimensions: PropTypes.object,
  dimensionsMobile: PropTypes.object,
  alt: PropTypes.string,
  order: PropTypes.number,
  textPositionMobile: PropTypes.string,
  gap: PropTypes.string,
  embedded: PropTypes.object,
};

export default MediaGridShell;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/common/MediaGrid.js